export const remoteConfigMock = {
    globalConfig: {
        notaFiscalUrlReceitaFederal: "https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?nfe=",
        consultaNotaFiscalUrl: "https://scanner.americanas.io/nota-fiscal",
        daysToDevolution: {
            normal: 15,
            sfsEstadual: 30,
            iFood: 7
        },
        isDevolutionAllowedForSalesChannel: {
            allowedSaleChannels: ['magalu', 'shopee', 'rappi', 'ifood']
        },
        isDeliverymanBackBlockedForSalesChannel: {
            allowedSaleChannels: ['99food', 'rappi']
        },
        minutosPedidoAtrasado: 15,
        minutosIntervaloBuscaPedidoAtrasado: 5,
        alertaPedidoAtrasadoHabilitado: true,
        menusHabilitados: {
            estimated: false
        }
    },
    modules: {
        order: {
            enabled: true,
            allowedStores: [],
            pages: {
                details: {
                    enabled: true,
                    allowedStores: [],
                    toggleFeatures: {
                        newReceipt: true,
                        allowTakeoutOrderWithoutNF: true
                    }
                }
            }
        }
    }
}